module.exports = __webpack_public_path__ + "img/font_boere-tudor.63dbcab.svg";